// extracted by mini-css-extract-plugin
export default {"root":"misalignment_item-module___root___ca749252","valuesContainer":"misalignment_item-module___valuesContainer___b1b3108a"};